export default __webpack_public_path__ + "assets/lifeStory.73884052.svg";